import React from 'react';

import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';
import { LoadablePaint } from '@confluence/loadable';
import {
	CONTAINER_ADMIN_HOME_ID,
	CONTAINER_HOME_ID,
} from '@confluence/app-navigation/entry-points/navigationIDs.ts';

const SpaceLookAndFeelSettingsRouteComponent = LoadablePaint({
	loader: async () =>
		import(
			/* webpackChunkName: "loadable-SpaceLookAndFeelSettingsRouteComponent" */ './SpaceLookAndFeelSettingsRouteComponent.tsx'
		),
});

export const SpaceLookAndFeelSettingsRoute = ({ params: { spaceKey, tab } }: RouteMatch) => {
	return <SpaceLookAndFeelSettingsRouteComponent spaceKey={spaceKey} tab={tab} />;
};

SpaceLookAndFeelSettingsRoute.NAVIGATION_PARAMS = (
	{ name, params: { spaceKey } },
	isNav4Enabled,
) => ({
	Screen: {
		screenEvent: {
			name: 'spaceSettingLookAndFeelPage',
			id: spaceKey,
		},
		pageState: {
			routeName: name,
			spaceKey,
		},
	},
	MainLayout: {
		navView: isNav4Enabled ? CONTAINER_ADMIN_HOME_ID : CONTAINER_HOME_ID,
		spaceKey,
	},
});
